module.exports = __webpack_public_path__ + "img/kate_macK210724.6683baaa.jpg";